import { createAsyncThunk } from "@reduxjs/toolkit";
import { BANNERIMAGES } from "../../../API/UserApi";

import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const deleteBannerImagesAPI: any = createAsyncThunk(
  "deleteBannerImages",
  async (rowId: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);

    try {
      const res = await axios.delete(BANNERIMAGES + "/" + rowId, {
        // headers: {
        //   token: JSON.parse(token),
        // },
        headers: commonHead,
      });
      ;
      return { bannerImageDeleted: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
